import serialize from 'serialize-javascript';
import jsStringEsc from 'js-string-escape';
export function getAdsSSRConfig(session) {
    var _session_features_includes, _this, _session, _session_features_reduce, _this1, _session1, _session_adsTargeting;
    if (!session.adsEnabled) {
        return {
            shouldIncludeGak: false,
            shouldIncludeFreestar: false,
            shouldIncludeQuantcast: false,
            shouldIncludeHashtag: false,
            adsDebug: false
        };
    }
    // Logged in ads use GAK
    if (session.adProviders.includes('da')) {
        var _session_features_includes1, _this2, _session2, _session_features_reduce1, _this3, _session3, _session_adsTargeting1;
        return {
            shouldIncludeFreestar: false,
            shouldIncludeHashtag: false,
            shouldIncludeGak: true,
            shouldIncludeQuantcast: true,
            adsDebug: ((_this2 = (_session2 = session) === null || _session2 === void 0 ? void 0 : _session2.features) === null || _this2 === void 0 ? void 0 : (_session_features_includes1 = _this2.includes) === null || _session_features_includes1 === void 0 ? void 0 : _session_features_includes1.call(_this2, 'ads_debug')) ? true : false,
            gakContext: toJsonString({
                features: (_this3 = (_session3 = session) === null || _session3 === void 0 ? void 0 : _session3.features) === null || _this3 === void 0 ? void 0 : (_session_features_reduce1 = _this3.reduce) === null || _session_features_reduce1 === void 0 ? void 0 : _session_features_reduce1.call(_this3, (p, c)=>{
                    p[c] = true;
                    return p;
                }, {}),
                targeting: (_session_adsTargeting1 = session.adsTargeting) === null || _session_adsTargeting1 === void 0 ? void 0 : _session_adsTargeting1.page,
                ppId: session.user.ppId
            })
        };
    }
    if (session.adProviders.includes('hashtag')) {
        var _session_features_includes2, _this4, _session4, _session_features_reduce2, _this5, _session5, _session_adsTargeting2;
        return {
            shouldIncludeFreestar: false,
            shouldIncludeHashtag: true,
            shouldIncludeGak: false,
            shouldIncludeQuantcast: true,
            adsDebug: ((_this4 = (_session4 = session) === null || _session4 === void 0 ? void 0 : _session4.features) === null || _this4 === void 0 ? void 0 : (_session_features_includes2 = _this4.includes) === null || _session_features_includes2 === void 0 ? void 0 : _session_features_includes2.call(_this4, 'ads_debug')) ? true : false,
            gakContext: toJsonString({
                features: (_this5 = (_session5 = session) === null || _session5 === void 0 ? void 0 : _session5.features) === null || _this5 === void 0 ? void 0 : (_session_features_reduce2 = _this5.reduce) === null || _session_features_reduce2 === void 0 ? void 0 : _session_features_reduce2.call(_this5, (p, c)=>{
                    p[c] = true;
                    return p;
                }, {}),
                targeting: (_session_adsTargeting2 = session.adsTargeting) === null || _session_adsTargeting2 === void 0 ? void 0 : _session_adsTargeting2.page,
                ppId: session.user.ppId
            })
        };
    }
    // Anon uses freestar
    return {
        shouldIncludeFreestar: true,
        shouldIncludeGak: false,
        shouldIncludeQuantcast: true,
        shouldIncludeHashtag: false,
        adsDebug: ((_this = (_session = session) === null || _session === void 0 ? void 0 : _session.features) === null || _this === void 0 ? void 0 : (_session_features_includes = _this.includes) === null || _session_features_includes === void 0 ? void 0 : _session_features_includes.call(_this, 'ads_debug')) ? true : false,
        gakContext: toJsonString({
            features: (_this1 = (_session1 = session) === null || _session1 === void 0 ? void 0 : _session1.features) === null || _this1 === void 0 ? void 0 : (_session_features_reduce = _this1.reduce) === null || _session_features_reduce === void 0 ? void 0 : _session_features_reduce.call(_this1, (p, c)=>{
                p[c] = true;
                return p;
            }, {}),
            targeting: (_session_adsTargeting = session.adsTargeting) === null || _session_adsTargeting === void 0 ? void 0 : _session_adsTargeting.page,
            ppId: session.user.ppId
        })
    };
}
export function isSSR() {
    return typeof window === 'undefined';
}
function jsStringEscape(json) {
    const result = jsStringEsc(json);
    return `"${result.replace(/<\/(script|style)/gi, '<\\/$1').replace(/<!--/g, '\\u003C!--')}"`;
}
export function toJsonString(jsObject, newrelic = null, newrelicSegmentName = '') {
    if (newrelic) {
        const segment = newrelicSegmentName || 'TO_JSON';
        return newrelic.startSegment(segment, true, ()=>jsStringEscape(serialize(jsObject, {
                isJSON: true
            })));
    }
    return jsStringEscape(serialize(jsObject, {
        isJSON: true
    }));
}
